(() => {
  const PRIVATE_SALE_PROPERTY = '_private_sale';

  const isCustomerLoggedIn = () =>
    document.documentElement.dataset.customerLoggedIn === 'true';

  const hasEligibleProduct = () =>
    !!document.querySelector('[data-pdp-545][data-private-sale-product-eligible="true"]');

  const isPrivateSaleContext = () =>
    isCustomerLoggedIn() && hasEligibleProduct();

  const shouldSendPrivateSaleProperty = () =>
    isPrivateSaleContext();

  let wasPrivateSaleContext = false;

  const addPrivateSalePropertyToForm = (form) => {
    if (!shouldSendPrivateSaleProperty() || !(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    let input = form.querySelector(`input[name="properties[${PRIVATE_SALE_PROPERTY}]"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${PRIVATE_SALE_PROPERTY}]`;
      form.appendChild(input);
    }

    input.value = 'true';
  };

  const initializeProductForms = (root = document) => {
    if (root instanceof HTMLFormElement && root.matches('form[action*="/cart/add"]')) {
      addPrivateSalePropertyToForm(root);
    }

    root
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach(addPrivateSalePropertyToForm);
  };

  const preservePrivateSaleLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!link.closest('[data-private-sale-context]')) return;
  };

  const preservePrivateSaleLinks = (root = document) => {
    if (!isCustomerLoggedIn()) return;

    if (root instanceof HTMLAnchorElement && root.matches('a[href*="/products/"]')) {
      preservePrivateSaleLink(root);
    }

    root
      .querySelectorAll('a[href*="/products/"]')
      .forEach(preservePrivateSaleLink);
  };

  const markPrivateSaleContext = () => {
    const isContext = isPrivateSaleContext();
    document.documentElement.classList.toggle('private-sale-context', isContext);

    if (!isContext) {
      wasPrivateSaleContext = false;
      return;
    }

    document.querySelectorAll('[data-pdp-545][data-private-sale-product-eligible="true"]').forEach((section) => {
      section.dataset.privateSaleAuthorized = 'true';
    });

    if (!wasPrivateSaleContext) {
      document.dispatchEvent(new CustomEvent('fivefourfive:private-sale-context'));
    }

    wasPrivateSaleContext = true;
  };

  const initializePrivateSale = (root = document) => {
    markPrivateSaleContext();

    if (isPrivateSaleContext()) {
      initializeProductForms(root);
    }

    preservePrivateSaleLinks(root);
  };

  window.FIVEFOURFIVE_PRIVATE_SALE = {
    isActive: isPrivateSaleContext,
    shouldSendProperty: shouldSendPrivateSaleProperty,
    propertyName: PRIVATE_SALE_PROPERTY,
    applyToForm: addPrivateSalePropertyToForm
  };

  document.addEventListener('DOMContentLoaded', () => initializePrivateSale());

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="add"], button[type="submit"], input[type="submit"]');
    const form = button?.closest?.('form[action*="/cart/add"]');
    if (form) addPrivateSalePropertyToForm(form);
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) {
      addPrivateSalePropertyToForm(event.target);
    }
  }, true);

  document.addEventListener('shopify:section:load', (event) => {
    initializePrivateSale(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        initializePrivateSale(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
